module.exports = __webpack_public_path__ + "img/cart-xmark.788957ee.svg";